
















































































































import { Row, Col, Swipe, SwipeItem, Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { wxChatShare } from "@/common/wechat";
import request from "@/api/index";
import Base from "@/template/public/Base.vue";
import native from "@/common/Native";
import vertical from "@/components/multiple/Vertical.vue";
import novertical from "@/components/multiple/noVertical.vue";
import moreList from "@/components/multiple/moreList.vue";
import AppPrompt from "@/components/AppPrompt.vue";
import domtoimage from "dom-to-image";
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import VConsole from "vconsole";
import { dateFormat } from "@/common/Utils";
import nopage from "@/components/newchongqing404.vue";
import ImageViewComMu from "@/components/imageViewComMu.vue";
import requestNewchongqing from "@/api/newchongqing";
interface IShareInfo {
  /** 顶图	 */
  shareBg: string;
  /** 分享图标	 */
  shareLogo: string;
  /** 客户端名字	 */
  appName: string;
  /** 客户端下载地址	 */
  downloadUrl: string;
  /** 底图 */
  shareClose: string;
  /** scheme */
  schemeUrl: string;
}
@Component({
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    AppPrompt,
    vertical,
    novertical,
    moreList,
    ImageViewComMu
  }
})
export default class NewsMultiple extends Base {
  public request = new request();
  private imgList: Array<object> = [];
  private imgListAcross: Array<object> = [];
  private imgInfo: object | any = {};
  // private id: string = "";
  private appId: string = "";
  private current: string = "";
  private bg: string = "0.5";
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  vfrom: string = ""; //是否预览

  //
  isShowVertical = true; // 是否手机横着  false就是横着  true是竖着
  isAcrossWidth: any = 0; // 横着的手机宽度  竖着的手机高度
  isAcrossHeight: any; // 横着的手机高度  竖着的手机宽度
  i: any = 0; // 默认第一张
  currentIndex = 0; //
  isApp = false;
  imgMoreList = []; // 推荐更多列表
  showMore = false; // 是否显示推荐更多

  // 海报等功能的参数
  private posterTitle: string = "";
  private requestLoaded: boolean = false;
  private isPlay: boolean = false;
  extinfo: any = "";
  private showPoster: boolean = false;
  private showLoading: boolean = false;
  private posterImg: string = "";
  private qrcodeSrc: string = "";
  private posterTopImg: string = "";
  private posterCreateTime: string = "";
  private posterDetail: {
    posterShare: string | number;
    posterImg: string;
  } = {
    posterShare: "",
    posterImg: ""
  };
  private id: string | any = "";
  private isOpenApp: boolean = false;
  mounted() {
    this.isApp = ZWY_CLOUD.isOpenInApp() || false;
    this.id = this.$route.query.id as string;
    this.appId = this.$route.query.appId as string;
    this.vfrom = (this.$route.query.vfrom as string) || "";
    this.getImgList();
    this.getCount();
    //九龙坡 预览新闻时, 底部评论和顶部分享不显示
    if (this.vfrom && ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "0",
        isShowMoreBtn: "0"
      });
      ZWY_CLOUD.bottomBarConfig({
        isShowBottom: 0,
        callBack_replyList: "releaseReplyList",
        praiseNum: 0,
        isPraised: 0
      });
    }
    if (ZWY_CLOUD.isOpenInApp()) {
      // get用户信息
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.getBussinessDetail();
      });
    } else {
      this.getBussinessDetail();
    }
    if (this.isApp) {
      //app内就走app的监听
      let that = this;
      (window as any).appResizeStauts = function appResizeStauts(
        stauts: number
      ) {
        if (stauts == 1 || stauts == 3) {
          that.isShowVertical = false;
        } else {
          that.isShowVertical = true;
        }
        that.currentIndex = that.i;
      };
    } else {
      //app外监听事件
      this.renderResize();
      window.addEventListener("resize", this.renderResize, false);
    }
  }

  // 获取多图列表
  getImgList() {
    return this.request
      .getList(this.id)
      .then(res => {
        if (res.code === 0) {
          // console.log(res.data);
          this.imgInfo = res.data;
          this.posterTitle =
            this.imgInfo.title.length > 26
              ? this.imgInfo.title.slice(0, 26) + "..."
              : this.imgInfo.title;
          if (this.imgInfo.audioUrl) {
            this.isPlay = true;
          } else {
            this.isPlay = false;
          }
          document.title = this.imgInfo.richTitle || this.imgInfo.title;
          this.imgList = this.imgInfo.appResource;
          // 不改变原数组反向  横屏滑动定位的顺序是反的
          let imgListCopy = [...this.imgList];
          this.imgListAcross = imgListCopy.reverse();
          this.appId = this.imgInfo.appId;
          this.$store.commit("SET_STATE", {
            appId: this.appId
          });
          // 推荐获取
          this.getMoreImgList(this.imgInfo.infoClassifyId);
          // 分享信息获取
          this.getBaseappInfoConfigList(this.imgInfo.appId);
          this.detailGetAppId = this.imgInfo.appId;

          let params = {
            contextType: this.imgInfo.contextType, // contextType 竖版视频传5  多图新闻传1 其他的也传1
            detailViewType: "2", // 写死传2
            id: this.imgInfo.infoClassifyId, //新闻id
            videoFormat: "-1", //  videoFormat竖屏新闻传2  别的为-1
            shareUrl: window.location.href, //新闻url
            url: window.location.href, // 新闻url
            sourceId: this.imgInfo.infoClassifyId, // sourceId
            sourceType: "", // sourceType空字符串
            thirdUrlEncode: false,
            title: "", // title空字符串
            shareTitle: "" // shareTitle空字符串
          };
          console.log(params);
          this.extinfo = JSON.stringify(params);
          const el = this.$refs.ImageViewCom as any;
          el.openView(0);
        }
      })
      .finally(() => {
        this.requestLoaded = true;
      });
  }
  //多图推荐
  getMoreImgList(infoClassifyId: any) {
    return this.request
      .getImgMore(infoClassifyId)
      .then(res => {
        if (res.code === 0) {
          let data = res.data;
          this.imgMoreList = data.dataList;
          if (this.imgMoreList) {
            this.showMore = true;
          } else {
            this.showMore = false;
          }
        } else {
          this.showMore = false;
        }
      })
      .catch(() => {
        this.showMore = false;
      });
  }
  // 业务详情
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        this.id,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }
  // 浏览量
  getCount() {
    if (!native.isOpenInApp()) {
      // 在app外才需要增加浏览量
      this.request.getCount(this.appId, this.id);
    }
  }
  // 横竖屏监听
  renderResize() {
    let width = document.documentElement.clientWidth;
    let height = document.documentElement.clientHeight;
    if (width > height) {
      //横
      this.isShowVertical = false;
      this.isAcrossHeight = document.body.clientHeight;
      this.isAcrossWidth = document.body.clientWidth;
    } else {
      //竖
      this.isShowVertical = true;
      this.isAcrossHeight = document.body.clientWidth;
      this.isAcrossWidth = document.body.clientHeight;
    }
    this.currentIndex = this.i;
  }
  // 统一横竖屏切换的index
  // 竖版
  getCurrentIndexV(data: any) {
    // data是当前的index
    console.log("huoquV" + data);
    this.i = data;
    const el = this.$refs.ImageViewCom as any;
    el.openView(data);
  }
  //横版
  getCurrentIndexH(data: any) {
    // data是当前的index
    console.log("huoquH" + data);
    this.i = data;
  }
}
